
import ReactDOM from 'react-dom';
import React from 'react'

import "../src/i18n";
import store from './redux/store.js';
import { Provider } from 'react-redux'
import AppLayout from './pages/appLayout/AppLaout';
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBFzaOYDyJkvIIgj1plP1oyhd40eJFQgrI",
  authDomain: "react-admin-panel-93fa3.firebaseapp.com",
  projectId: "react-admin-panel-93fa3",
  storageBucket: "react-admin-panel-93fa3.appspot.com",
  messagingSenderId: "46468496518",
  appId: "1:46468496518:web:5c8ebd98fdfab6a0f56507",
  measurementId: "G-Y1T966WTYH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);


ReactDOM.render(
  <Provider store={store}>

    <AppLayout />
    

  </Provider>,
  document.getElementById('root')
)



